import { DOCS_BASE_PATH } from "../../pages/docs/config/docConstants";

export function buildRouteMaps(docNav) {
  const routeToId = {};
  const idToRoute = {};

  docNav.forEach((group) => {
    group.items.forEach((item) => {
      routeToId[item.route] = item.id;
      idToRoute[item.id] = item.route;
    });
  });

  return { routeToId, idToRoute };
}

export function getSectionIdForRoute(docNav, route) {
  const { routeToId } = buildRouteMaps(docNav);
  return routeToId[route] ?? null;
}

export function getRouteForSectionId(docNav, sectionId) {
  const { idToRoute } = buildRouteMaps(docNav);
  return idToRoute[sectionId] ?? null;
}

export function getDocsPath(docNav, sectionId) {
  const route = getRouteForSectionId(docNav, sectionId);
  return route ? `${DOCS_BASE_PATH}/${route}` : DOCS_BASE_PATH;
}

export function getSectionIdFromPathname(docNav, pathname) {
  const segment = pathname
    .replace(new RegExp(`^${DOCS_BASE_PATH}/?`), "")
    .split("/")[0];

  if (!segment) {
    return getSectionIdForRoute(docNav, "overview") ?? "overview";
  }

  return getSectionIdForRoute(docNav, segment);
}

export function validateDocRoutes(docNav) {
  const errors = [];
  const seenRoutes = new Set();
  const seenIds = new Set();

  docNav.forEach((group) => {
    group.items.forEach((item) => {
      if (!item.route) {
        errors.push(`Missing route: ${group.id}/${item.id}`);
      }
      if (item.route && seenRoutes.has(item.route)) {
        errors.push(`Duplicate route: ${item.route}`);
      }
      if (seenIds.has(item.id)) {
        errors.push(`Duplicate id: ${item.id}`);
      }
      if (item.route) {
        seenRoutes.add(item.route);
      }
      seenIds.add(item.id);
    });
  });

  return errors;
}
